import { CheckCircle2 } from "lucide-react";

import { RoleDetectionCard, RoleVisualData } from "@/components/RoleDetectionCard";

/**
 * Dark left panel on /request-access: a detection card in the homepage hero's
 * style, with its own photo per role, plus three role-specific trust badges.
 * Hidden on small screens.
 */
export function AccessVisual({ badges, visual }: { badges: string[]; visual: RoleVisualData }) {
  return (
    <div className="relative bg-brand-900 hidden lg:block overflow-hidden">
      {/* Subtle grid */}
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.15) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.15) 1px, transparent 1px)",
          backgroundSize: "32px 32px",
        }}
      />

      <div className="relative flex flex-col gap-6 p-8">
        <RoleDetectionCard {...visual} />

        <div className="space-y-2">
          {badges.map((item) => (
            <div key={item} className="flex items-center gap-2">
              <CheckCircle2 size={14} className="text-brand-400 shrink-0" />
              <span className="text-white/80 text-sm">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
